import CheckMaxFreespinsReached from "slotworks/state-machine/standard/decisions/check-max-freespins-reached";
import FreespinsRetriggered from "slotworks/state-machine/standard/decisions/freespins-retriggered";
import FreespinsTriggered from "slotworks/state-machine/standard/decisions/freespins-triggered";
import HasExpansion from "slotworks/state-machine/standard/decisions/has-expansion";
import HasMoreRecords from "slotworks/state-machine/standard/decisions/has-more-records";
import InFreespins from "slotworks/state-machine/standard/decisions/in-freespins";
import IsAutoplay from "slotworks/state-machine/standard/decisions/is-autoplay";
import IsRecovery from "slotworks/state-machine/standard/decisions/is-recovery";
import IsRecoveryFreespins from "slotworks/state-machine/standard/decisions/is-recovery-freespins";
import IsWin from "slotworks/state-machine/standard/decisions/is-win";
import IsWinOverThreshold from "slotworks/state-machine/standard/decisions/is-win-over-threshold";
import ShouldExitFreespins from "slotworks/state-machine/standard/decisions/should-exit-freespins";
import Autoplay from "slotworks/state-machine/standard/states/autoplay";
import BigWins from "slotworks/state-machine/standard/states/big-wins";
import EnterFreespins from "slotworks/state-machine/standard/states/enter-freespins";
import EnterRecoveryFreespins from "slotworks/state-machine/standard/states/enter-recovery-freespins";
import ExitFreespins from "slotworks/state-machine/standard/states/exit-freespins";
import ExpandSymbols from "slotworks/state-machine/standard/states/expand-symbols";
import FreespinIdle from "slotworks/state-machine/standard/states/freespin-idle";
import GameOver from "slotworks/state-machine/standard/states/game-over";
import HighlightWins from "slotworks/state-machine/standard/states/highlight-wins";
import Idle from "slotworks/state-machine/standard/states/idle";
import Init from "slotworks/state-machine/standard/states/init";
import LoopWins from "slotworks/state-machine/standard/states/loop-wins";
import MaxFreespins from "slotworks/state-machine/standard/states/max-freespins";
import Recover from "slotworks/state-machine/standard/states/recover";
import RecoverSpin from "slotworks/state-machine/standard/states/recover-spin";
import RecoverStickySymbols from "slotworks/state-machine/standard/states/recover-sticky-symbols";
import RequestFreespin from "slotworks/state-machine/standard/states/request-freespin";
import RequestSpin from "slotworks/state-machine/standard/states/request-spin";
import RetriggerFreespins from "slotworks/state-machine/standard/states/retrigger-freespins";
import ShowWinLines from "slotworks/state-machine/standard/states/show-win-lines";
import Spin from "slotworks/state-machine/standard/states/spin";
import WinCycle from "slotworks/state-machine/standard/super-states/win-cycle";
import StateMachine from "slotworks/state-machine/state-machine";
import StateRegister from "slotworks/state-machine/state-register";

export default class StandardStates {

    public static init() {

        // --- Main game
        // States
        StateRegister.add("init", new Init(StateMachine));
        StateRegister.add("idle", new Idle(StateMachine));
        StateRegister.add("request-spin", new RequestSpin(StateMachine));
        StateRegister.add("spin", new Spin(StateMachine));
        StateRegister.add("highlight-wins", new HighlightWins(StateMachine));
        StateRegister.add("show-win-lines", new ShowWinLines(StateMachine));
        StateRegister.add("big-wins", new BigWins(StateMachine));
        StateRegister.add("autoplay", new Autoplay(StateMachine));
        StateRegister.add("game-over", new GameOver(StateMachine));
        StateRegister.add("loop-wins", new LoopWins(StateMachine));
        StateRegister.add("expand-symbols", new ExpandSymbols(StateMachine));

        // Decisions
        StateRegister.add("is-autoplay", new IsAutoplay());
        StateRegister.add("is-win-over-threshold", new IsWinOverThreshold());
        StateRegister.add("is-win", new IsWin());
        StateRegister.add("has-expansion", new HasExpansion());
        StateRegister.add("has-more-records", new HasMoreRecords());

        // Super states
        StateRegister.add("win-cycle", new WinCycle(StateMachine));

        // --- Free spins
        // States
        StateRegister.add("enter-freespins", new EnterFreespins(StateMachine));
        StateRegister.add("exit-freespins", new ExitFreespins(StateMachine));
        StateRegister.add("retrigger-freespins", new RetriggerFreespins(StateMachine));
        StateRegister.add("max-freespins", new MaxFreespins(StateMachine));
        StateRegister.add("freespin-idle", new FreespinIdle(StateMachine));
        StateRegister.add("request-freespin", new RequestFreespin(StateMachine));

        // Decisions
        StateRegister.add("freespins-triggered", new FreespinsTriggered());
        StateRegister.add("freespins-retriggered", new FreespinsRetriggered());
        StateRegister.add("in-freespins", new InFreespins());
        StateRegister.add("should-exit-freespins", new ShouldExitFreespins());
        StateRegister.add("max-freespins-reached", new CheckMaxFreespinsReached());

        // --- Recovery
        // States
        StateRegister.add("enter-recovery", new Recover(StateMachine));
        StateRegister.add("enter-recovery-spin", new RecoverSpin(StateMachine));
        StateRegister.add("enter-recovery-freespins", new EnterRecoveryFreespins(StateMachine));
        StateRegister.add("recover-sticky-symbols", new RecoverStickySymbols(StateMachine));

        // Decisions
        StateRegister.add("is-recovery", new IsRecovery());
        StateRegister.add("is-recovery-freespins", new IsRecoveryFreespins());

    }
}



// WEBPACK FOOTER //
// ./~/slotworks/state-machine/standard/standard-states.ts